import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import { gfmHeadingId } from 'marked-gfm-heading-id';
import DOMPurify from 'dompurify';  // You'll need to install this

interface MarkdownContentProps {
  content: string;
  className?: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content = '', className = '' }) => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    if (!content) return;

    const processContent = async () => {
      const rawHtml = await marked(content);
      const sanitizedHtml = DOMPurify.sanitize(rawHtml, {
        ALLOWED_TAGS: ['p', 'strong', 'em', 'h1', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'blockquote', 'br'],
        ALLOWED_ATTR: ['class']
      });
      setHtml(sanitizedHtml);
    };

    processContent();
  }, [content]);

  return (
    <div 
      className={`prose max-w-none prose-orange
        prose-headings:font-semibold prose-headings:text-gray-800
        prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl
        prose-p:text-gray-600 prose-p:leading-relaxed
        prose-li:text-gray-600
        prose-strong:text-gray-800 prose-strong:font-bold
        prose-ul:list-disc prose-ul:pl-6
        prose-ol:list-decimal prose-ol:pl-6
        prose-blockquote:border-l-4 prose-blockquote:border-orange-200
        prose-blockquote:pl-4 prose-blockquote:italic
        overflow-hidden break-words w-full
        ${className}`}
      dangerouslySetInnerHTML={{ __html: html }} 
    />
  );
}; 